import type { FaireProductEntity } from "../../entity_types/product";

export const p_tqmeru5286: FaireProductEntity = {
  token: "p_tqmeru5286",
  type: "product",
  name: "Fuck Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/ba843390569b36c08969777c0d0e054ad57cbbb03042696013df68278ad60733.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8b69e3bb707f9f76ab34dd81ca465b6adfb887ec13550036c5863aed3ddf5780.jpeg",
    "https://cdn.faire.com/fastly/0b96450adca170a07738403072f8a894da5df3ee91562f7d0a263f2b36c55a6c.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/65774ca68e781c982db884e67a14b715f699005e502869301194fd4e310235ea.jpeg",
    "https://cdn.faire.com/fastly/e33352af4df5f4f82a52444202b13d2b8bee9cac2e063ab4663a8219d7587b25.jpeg",
    "https://cdn.faire.com/fastly/9bc2735d2f70c37e880bfe16cfed3b5e70134e2ea8ade9316ce8d245ed1e546a.jpeg",
    "https://cdn.faire.com/fastly/9fc920451535f1ebcf4be38b087a42d24bae296ce28662c772e165a74fe66f1c.jpeg",
    "https://cdn.faire.com/fastly/f701365ba55e894f7f92d13b2117d5b5bf8bad679009674c4a2253d4be135d51.jpeg"
  ],
  priceDollars: 6.75,
  description: "Sometimes all it takes is a single word to let the world know what's up. Sport the socks with the most versatile word in the world. Noun? Verb? Interjection? All of the above! Keep your feet clean and your socks FILTHY. 😝\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:27:57.317Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
